import React, {useEffect, useState} from "react";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {Grid, TextField, Typography} from "@mui/material";
import ButtonGroup from '@mui/material/ButtonGroup';
import {useNavigate, useSearchParams} from 'react-router-dom';
import "./OneShot.css";
import useMediaQuery from '@mui/material/useMediaQuery';
import {styled, useTheme} from '@mui/material/styles';
import Button from '@mui/material/Button';
import {getCookie, setCookie} from '../../utils/Functions';

import Slide from '@mui/material/Slide';
//Images
import fondoDonacion from "../../assets/imgs/unicef/OneShot/teleton2025/banner-Desktop.png"
import mobileFondoDonacion from "../../assets/imgs/unicef/OneShot/teleton2025/banner-Mobile.png"
import fondoPrincipal from "../../assets/imgs/unicef/OneShot/teleton2025/banner-Desktop.png"
import mobileFondoPrincipal from "../../assets/imgs/unicef/OneShot/teleton2025/banner-Mobile.png"

// Reusable Components
const DonarAhoraButton = ({ onClick, text = "DONAR AHORA", mobile = false, customText = false }) => (
    <button
        onClick={onClick}
        style={{
            backgroundColor: '#EE5B28',
            color: '#ffffff',
            border: 'none',
            borderRadius: '35px',
            padding: mobile ? '12px 30px' : '15px 40px',
            fontSize: mobile ? (customText ? '16px' : '18px') : '20px',
            fontWeight: 'bold',
            fontFamily: 'inherit',
            cursor: 'pointer',
            textTransform: 'uppercase'
        }}
        className="font-face-UniversBold"
    >
        {text}
    </button>
);

const WhiteSection = ({ children, mobile = false, textAlign = "center", padding = null }) => (
    <section style={{
        backgroundColor: '#ffffff',
        width: '100%',
        padding: padding || (mobile ? '30px 20px' : '40px 10.4%'),
        textAlign
    }}>
        {children}
    </section>
);

const ColorButton = styled(Button)(({theme}) => ({
    color: theme.palette.getContrastText("#fff"),
    fontSize: 20,
    fontWeight: "700",
    padding: 1,
    height: 65,
    borderRadius: 3,
    width: "100%",
    backgroundColor: "#ffff00",
    '&:hover': {
        backgroundColor: "#fff",
        color: "#000"
    },
}));

const OneShot = (props) => {

    const navigate = useNavigate();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [showAmount, setShowAmount] = useState(false);
    const [error, setError] = useState("");
    const [isFirstClick, setIsFirstClick] = useState(true);

    const [amount, setAmount] = useState(120);
    const [imgDonacion, setImgDonacion] = useState(false);
    const [searchParams] = useSearchParams();

    // Image constants - centralized image paths
    const BASE_URL = process.env.REACT_APP_URL_CONFIG;
    const IMAGES = {
        kids: {
            kid1: `${BASE_URL}/assets/imgs/teleton2025/kid1.png`,
            kid2: `${BASE_URL}/assets/imgs/teleton2025/kid2.png`,
            kid3: `${BASE_URL}/assets/imgs/teleton2025/kid3.png`,
            kid4: `${BASE_URL}/assets/imgs/teleton2025/kid4.png`,
            kid5: `${BASE_URL}/assets/imgs/teleton2025/kid5.png`,
            kid6: `${BASE_URL}/assets/imgs/teleton2025/kid6.png`
        },
        teleton: {
            banner1: `${BASE_URL}/assets/imgs/teleton2025/teleton-banner1.png`
        }
    };

    // Legacy variable names for compatibility
    const kid1 = IMAGES.kids.kid1;
    const kid2 = IMAGES.kids.kid2;
    const teletonBanner1 = IMAGES.teleton.banner1;
    const kid11 = IMAGES.kids.kid2;
    const kid12 = IMAGES.kids.kid3;
    const kid13 = IMAGES.kids.kid4;
    const kid5 = IMAGES.kids.kid5;
    const kid6 = IMAGES.kids.kid6;

    const [finalData, setFinalData] = useState({

        utm_source: searchParams.get("utm_source") ? searchParams.get("utm_source") : "false",
        utm_medium: searchParams.get("utm_medium") ? searchParams.get("utm_medium") : "false",
        utm_campaign: searchParams.get("utm_campaign") ? searchParams.get("utm_campaign") : "false",
        utm_id: searchParams.get("utm_id") ? searchParams.get("utm_id") : "false",
        utm_term: searchParams.get("utm_term") ? searchParams.get("utm_term") : "false",
        utm_content: searchParams.get("utm_content") ? searchParams.get("utm_content") : "false"
    })

    const handleChange = (event) => {

        if (event.target.value === "") {
            setAmount(event.target.value)
        } else {

            if (/^[0-9]+$/.test(event.target.value)) {
                //
                setError("")
                setAmount(event.target.value)
                if (event.key === 'Enter') {
                    //
                    donate(event)
                }
            }
        }
    };
    const donate = (event) => {
        //
        if (parseInt(amount) >= 100) {
            if (process.env.REACT_APP_URL_CONFIG === "https://www.unicef.org.bo") {
                window.fbq('track', 'AddToCart', {
                    content_type: 'product',
                    value: amount,
                    currency: "BOB"
                });
                window.gtag("event", "add_to_cart", {
                    currency: "BOB",
                    value: amount,
                    items: [
                        {
                            item_id: "SKU_DONACION",
                            item_name: "Donación de " + amount + "Bs",
                            price: amount,
                            quantity: 1
                        }
                    ]
                });
            } else {

            }

            setTimeout(() => {

                window.scrollTo(0, 0)
            }, 100);
            navigate("/donacion-unica-completar/" + amount);
        } else {
            setError("El monto debe ser mayor a Bs 100")
        }
    }

    useEffect(() => {

        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 100);

        let utm_source = ""
        let utm_id = ""
        let utm_content = ""
        let utm_medium = ""
        let utm_campaign = ""
        let utm_term = ""
        let _finalData = finalData

        if (searchParams.get("utm_source")) {
            utm_source = searchParams.get("utm_source")

            _finalData["utm_source"] = utm_source
        } else {
            utm_source = getCookie(process.env.REACT_APP_NAME + "utm_source")
            if (!utm_source || utm_source === "undefined" || utm_source === undefined || utm_source === null || utm_source === "null") {
                utm_source = ""
            }
            _finalData["utm_source"] = utm_source
        }

        if (searchParams.get("utm_term")) {
            _finalData["utm_term"] = utm_term
            utm_term = searchParams.get("utm_term")
        } else {
            utm_term = getCookie(process.env.REACT_APP_NAME + "utm_term")
            if (!utm_term || utm_term === "undefined" || utm_term === undefined || utm_term === null || utm_term === "null") {
                utm_term = ""
            }
            utm_term = searchParams.get("utm_term")
        }

        if (searchParams.get("utm_id")) {
            utm_id = searchParams.get("utm_id")
            _finalData["utm_id"] = utm_id
        } else {
            utm_id = getCookie(process.env.REACT_APP_NAME + "utm_id")
            if (!utm_id || utm_id === "undefined" || utm_id === undefined || utm_id === null || utm_id === "null") {
                utm_id = ""
            }
            _finalData["utm_id"] = utm_id
        }

        if (searchParams.get("utm_content")) {
            utm_content = searchParams.get("utm_content")
            _finalData["utm_content"] = utm_content
        } else {
            utm_content = getCookie(process.env.REACT_APP_NAME + "utm_content")
            if (!utm_content || utm_content === "undefined" || utm_content === undefined || utm_content === null || utm_content === "null") {
                utm_content = ""
            }
            _finalData["utm_content"] = utm_content
        }

        if (searchParams.get("utm_medium")) {
            utm_medium = searchParams.get("utm_medium")
            _finalData["utm_medium"] = utm_medium
        } else {
            utm_medium = getCookie(process.env.REACT_APP_NAME + "utm_medium")
            if (!utm_medium || utm_medium === "undefined" || utm_medium === undefined || utm_medium === null || utm_medium === "null") {
                utm_medium = ""
            }
            _finalData["utm_medium"] = utm_medium
        }

        if (searchParams.get("utm_campaign")) {
            utm_campaign = searchParams.get("utm_campaign")
            _finalData["utm_campaign"] = utm_campaign
        } else {
            utm_campaign = getCookie(process.env.REACT_APP_NAME + "utm_campaign")
            if (!utm_campaign || utm_campaign === "undefined" || utm_campaign === undefined || utm_campaign === null || utm_campaign === "null") {
                utm_campaign = ""
            }
            _finalData["utm_campaign"] = utm_campaign
        }

        setTimeout(() => {
            setFinalData(_finalData)
        }, 100);

        //

        setCookie(process.env.REACT_APP_NAME + "utm_source", utm_source, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_id", utm_id, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_content", utm_content, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_medium", utm_medium, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_campaign", utm_campaign, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_term", utm_term, 0.5)

    })

    return (
        <>
            <div id="donation-form">
                <>
                    <section className="home-slider position-relative">
                        <img
                            src={fullScreen ? (imgDonacion ? mobileFondoDonacion : mobileFondoPrincipal) : (imgDonacion ? fondoDonacion : fondoPrincipal)}
                            alt='image'/>
                        {fullScreen && imgDonacion && false && (
                            <div className="donation-legend" style={{
                                zIndex: 800,
                                position: "absolute",
                                padding: "23px 10px",
                                bottom: "20px",
                                maxWidth: "50%"
                            }}>

                                <div>
                                    <p style={{
                                        fontSize: "1.5rem",
                                        color: "#ffffff",
                                        lineHeight: 1.1,
                                        textAlign: "left",
                                        paddingLeft: "20px"
                                    }}
                                       className={"font-face-UniversBold"}>Con {amount} Bs</p>
                                    <p style={{
                                        fontSize: "1rem",
                                        color: "#ffffff",
                                        lineHeight: 1.1,
                                        textAlign: "left",
                                        paddingLeft: "20px"
                                    }}
                                       className={"font-face-UniversLight"}>lograr&aacute;s transformar vidas</p>
                                </div>
                            </div>
                        )}
                        {!fullScreen && imgDonacion && false && (
                            <div style={{
                                flex: "50%",
                                position: "absolute",
                                bottom: "15%",
                                right: "5%"
                            }}>

                                <div>
                                    <p style={{
                                        fontSize: "4rem",
                                        color: "#ffffff",
                                        lineHeight: 1.1,
                                        textAlign: "right"
                                    }}
                                       className={"font-face-UniversRegular"}>Con {amount} Bs</p>
                                    <p style={{
                                        fontSize: "2rem",
                                        color: "#ffffff",
                                        lineHeight: 1.1,
                                        textAlign: "right"
                                    }}
                                       className={"font-face-UniversLight"}>lograr&aacute;s transformar vidas</p>
                                </div>

                            </div>
                        )}
                        {(
                            <div>
                                <div style={!fullScreen ? {
                                    zIndex: 9999,
                                    display: "flex",
                                    flexDirection: "column",
                                    position: "absolute",
                                    bottom: "20%",
                                    paddingLeft: "8%",
                                    maxWidth: "50%",
                                    padding: "23px 25px"
                                } : {
                                    display: "flex",
                                    position: "absolute",
                                    top: "55%",
                                    width: "82%",
                                    padding: "23px 10px"
                                }}>

                                    {!fullScreen && (
                                        <div class={"row"} style={{flex: !fullScreen ? "50%" : "100%",}}>
                                            <Grid container spacing={0} columnSpacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        sx={{mb: {xs: 4, md: 3, lg: 2}, mt: {xs: 4, md: 3, lg: 2}}}
                                                        variant={fullScreen ? "h3" : "h4"}
                                                        style={{
                                                            textAlign: fullScreen ? "center" : "left",
                                                            color: fullScreen ? "#000" : "#000",
                                                            background: "#FFFA2F",
                                                        }}>

                                                    </Typography>
                                                </Grid>
                                                <Grid item lg={3} xs={3}>
                                                    <ColorButton style={{
                                                        color: "#fff",
                                                        borderRadius: 45,
                                                        textTransform: "capitalize",
                                                        border: "2px solid #fff",
                                                        backgroundColor: amount === 120 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                                        marginTop: "20px",
                                                        width: "100%"
                                                    }} selected onClick={() => {
                                                        setError("");
                                                        setAmount(120);
                                                        setIsFirstClick(false);
                                                        setShowAmount(false);
                                                        setImgDonacion(true)
                                                    }} variant="contained"><span
                                                        className={"font-face-UniversBold"}>Bs 120</span></ColorButton>
                                                </Grid>

                                                <Grid item lg={3} xs={3} style={{position: "relative"}}>
                                                    <div style={{
                                                        position: "absolute",
                                                        top: "-8px",
                                                        left: "50%",
                                                        transform: "translateX(-40%)",
                                                        backgroundColor: "#fff",
                                                        color: "#1FA3DB",
                                                        padding: "4px 12px",
                                                        borderRadius: "12px",
                                                        fontSize: "11px",
                                                        fontWeight: "bold",
                                                        zIndex: 10,
                                                        whiteSpace: "nowrap"
                                                    }}>
                                                        Popular ♥
                                                    </div>
                                                    <div style={{
                                                        border: "2px dashed #fff",
                                                        borderRadius: "0px",
                                                        padding: "4px",
                                                        position: "relative",
                                                        marginTop: "12px"
                                                    }}>
                                                        <ColorButton style={{
                                                            color: "#fff",
                                                            borderRadius: 45,
                                                            textTransform: "capitalize",
                                                            border: "2px solid #fff",
                                                            backgroundColor: amount === 170 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                                            width: "100%"
                                                        }} onClick={() => {
                                                            setError("");
                                                            setAmount(170);
                                                            setIsFirstClick(false);
                                                            setShowAmount(false);
                                                            setImgDonacion(true)
                                                        }} variant="contained"><span
                                                            className={"font-face-UniversBold"}>Bs 170</span></ColorButton>
                                                    </div>
                                                    <div style={{
                                                        position: "absolute",
                                                        bottom: "-28px",
                                                        left: "50%",
                                                        transform: "translateX(-45%)",
                                                        color: "#fff",
                                                        fontSize: "11px",
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                        zIndex: 10,
                                                        whiteSpace: "nowrap",
                                                        lineHeight: "1"
                                                    }}>
                                                        <div style={{fontSize: "24px", marginBottom: "-2px"}}>▼</div>
                                                        Opción más elegida
                                                    </div>
                                                </Grid>
                                                <Grid item lg={3} xs={3}>
                                                    <ColorButton style={{
                                                        color: "#fff",
                                                        borderRadius: 45,
                                                        textTransform: "capitalize",
                                                        border: "2px solid #fff",
                                                        backgroundColor: amount === 250 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                                        marginTop: "20px",
                                                        width: "100%"
                                                    }} onClick={() => {
                                                        setError("");
                                                        setAmount(250);
                                                        setIsFirstClick(false);
                                                        setShowAmount(false);
                                                        setImgDonacion(true)
                                                    }} variant="contained"><span
                                                        className={"font-face-UniversBold"}>Bs 250</span></ColorButton>
                                                </Grid>
                                                <Grid item lg={3} xs={3}>
                                                    <ColorButton
                                                        style={{
                                                            color: "#fff",
                                                            borderRadius: 45,
                                                            textTransform: "capitalize",
                                                            border: "2px solid #fff",
                                                            backgroundColor: amount !== 120 && amount !== 170 && amount !== 250 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                                            fontSize: "1.1rem",
                                                            lineHeight: "1",
                                                            marginTop: "20px",
                                                            width: "100%"
                                                        }} onClick={() => {
                                                        setAmount(250);
                                                        setIsFirstClick(false);
                                                        setShowAmount(true);
                                                        setImgDonacion(true)
                                                    }} variant="contained"><span className={"font-face-UniversBold"}>Otro Monto Mayor</span></ColorButton>
                                                </Grid>
                                                <Grid item lg={12} xs={12}
                                                      sx={{mb: {xs: 4, md: 3, lg: 2}, mt: {xs: 4, md: 2, lg: 1}}}
                                                >
                                                </Grid>

                                                <Grid item lg={12} xs={12} mt={1} style={{textAlign: "center"}}>
                                                    {showAmount ?
                                                        <ButtonGroup
                                                            style={{width: "100%"}}
                                                            disableElevation
                                                            variant="contained"
                                                            aria-label="Disabled elevation buttons"
                                                        >
                                                            <TextField style={{width: "50%"}}
                                                                       className="amount-text"
                                                                       value={amount}
                                                                       onChange={handleChange}
                                                                       onKeyDown={handleChange}/>
                                                            <ColorButton onClick={donate} style={{
                                                                width: "50%",
                                                                backgroundColor: "#FFFA2F",
                                                                color: "#000"
                                                            }}><span
                                                                className={"font-face-UniversBold"}>Dona Ahora</span></ColorButton>
                                                        </ButtonGroup>
                                                        :
                                                        <ColorButton style={{
                                                            borderRadius: 35, backgroundColor: "#FFFA2F",
                                                            color: "#000", width: fullScreen ? "50%" : "60%"
                                                        }}
                                                                     onClick={donate}>Dona Ahora</ColorButton>
                                                    }
                                                </Grid>

                                                {error !== "" &&
                                                    <Grid item lg={12} xs={12} mt={1}>
                                                        <div style={{
                                                            background: "#000",
                                                            zIndex: "99",
                                                            fontSize: "1rem",
                                                            fontWeight: 600,
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            padding: 5,
                                                            borderRadius: 5
                                                        }}>
                                                            <WarningAmberIcon variant="h6"
                                                                              sx={{fontSize: "2rem", marginRight: 1}}/>
                                                            {error}
                                                        </div>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </section>

                    {/* Blue Section - Desktop only */}
                    {!fullScreen && (
                        <section style={{
                            backgroundColor: '#1FA3DB',
                            width: '100%',
                            padding: '60px 10.4%'
                        }}>
                            <div style={{
                                display: 'flex',
                                maxWidth: '100%',
                                gap: '40px',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                {/* Text */}
                                <div style={{
                                    flex: 1,
                                    textAlign: 'center'
                                }}>
                                    <Typography
                                        variant="h1"
                                        style={{
                                            color: '#ffffff',
                                            fontWeight: 'bold',
                                            lineHeight: 1.4,
                                            margin: 0,
                                            fontSize: '2.8rem !important',
                                            textAlign: 'center'
                                        }}
                                        className="font-face-UniversBold"
                                    >
                                        Con una sola donación, puedes cambiar el futuro de niñas y niños en Bolivia. Ayúdalos a acceder a salud, educación y protección.
                                    </Typography>
                                </div>
                            </div>

                            {/* Donate Button */}
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '40px'
                            }}>
                                <button
                                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                    style={{
                                        backgroundColor: '#EE5B28',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '35px',
                                        padding: '15px 40px',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        fontFamily: 'inherit',
                                        cursor: 'pointer',
                                        textTransform: 'uppercase'
                                    }}
                                    className="font-face-UniversBold"
                                >
                                    DONAR AHORA
                                </button>
                            </div>
                        </section>
                    )}

                    {/* White Section with Blue Text - Desktop */}
                    {!fullScreen && (
                        <section style={{
                            backgroundColor: '#ffffff',
                            width: '100%',
                            padding: '60px 10.4%',
                            textAlign: 'center'
                        }}>
                            {/* Blue Text */}
                            <Typography
                                variant="h2"
                                style={{
                                    color: '#1FA3DB',
                                    fontWeight: 'bold',
                                    lineHeight: 1.4,
                                    margin: 0,
                                    fontSize: '3.5rem',
                                    marginBottom: '15px'
                                }}
                                className="font-face-UniversBold"
                            >
                                Tú puedes cambiar sus vidas.
                            </Typography>
                            <Typography
                                variant="body1"
                                style={{
                                    color: '#333333',
                                    fontSize: '18px',
                                    lineHeight: 1.6,
                                    fontFamily: 'inherit',
                                    marginBottom: '40px'
                                }}
                            >
                                Tu donación se transforma en ayuda directa que llega a los lugares más alejados del país.
                            </Typography>

                            {/* Info Section - Desktop */}
                            <div style={{
                                backgroundColor: '#ffffff',
                                width: '100%',
                                padding: '0',
                                marginTop: '40px',
                                borderRadius: '15px',
                                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    maxWidth: '100%',
                                    maxHeight: '450px'
                                }}>
                                    {/* Left side - Image */}
                                    <div style={{
                                        width: '47%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <img
                                            src={kid1}
                                            alt="Kid"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    </div>

                                    {/* Right side - White section */}
                                    <div style={{
                                        width: '53%',
                                        backgroundColor: '#ffffff',
                                        padding: '48px 66px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-start'
                                    }}>
                                        {/* Equivalencias header */}
                                        <div style={{
                                            color: '#1FA3DB',
                                            fontSize: '2em',
                                            fontWeight: 'bold',
                                            fontFamily: 'inherit',
                                            marginBottom: '15px'
                                        }}>
                                            Equivalencias:
                                        </div>

                                        {/* Row 1 */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '20px'
                                        }}>
                                            <img
                                                src={kid11}
                                                alt="Kit"
                                                style={{
                                                    width: '80px',
                                                    height: '80px',
                                                    marginRight: '20px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div style={{
                                                display: 'flex',
                                                width: '100%'
                                            }}>
                                                <div style={{
                                                    width: '50%',
                                                    fontSize: '32px',
                                                    fontWeight: 'bold',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    textAlign: 'left',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    Bs 120 =
                                                </div>
                                                <div style={{
                                                    width: '50%',
                                                    fontSize: '20px',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    textAlign: 'right',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    2.285 niñas y niños reciben vitamina A en todo el país.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 2 */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '20px'
                                        }}>
                                            <img
                                                src={kid12}
                                                alt="Kit"
                                                style={{
                                                    width: '80px',
                                                    height: '80px',
                                                    marginRight: '20px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div style={{
                                                display: 'flex',
                                                width: '100%'
                                            }}>
                                                <div style={{
                                                    width: '50%',
                                                    fontSize: '32px',
                                                    fontWeight: 'bold',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    textAlign: 'left',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    Bs 170 =
                                                </div>
                                                <div style={{
                                                    width: '50%',
                                                    fontSize: '20px',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    textAlign: 'right',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    8 niñas y niños reciben kits de estimulación temprana en todo el país.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 3 */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            <img
                                                src={kid13}
                                                alt="Kit"
                                                style={{
                                                    width: '80px',
                                                    height: '80px',
                                                    marginRight: '20px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div style={{
                                                display: 'flex',
                                                width: '100%'
                                            }}>
                                                <div style={{
                                                    width: '50%',
                                                    fontSize: '32px',
                                                    fontWeight: 'bold',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    textAlign: 'left',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    Bs 250 =
                                                </div>
                                                <div style={{
                                                    width: '50%',
                                                    fontSize: '20px',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    textAlign: 'right',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    10 niñas y niños reciben kits de estimulación temprana en todo el país.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* Donate Button - moved outside shadow container */}
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '40px'
                            }}>
                                <button
                                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                    style={{
                                        backgroundColor: '#EE5B28',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '35px',
                                        padding: '15px 40px',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        fontFamily: 'inherit',
                                        cursor: 'pointer',
                                        textTransform: 'uppercase'
                                    }}
                                    className="font-face-UniversBold"
                                >
                                    TÚ TAMBIÉN PUEDES SER UN HÉROE O HEROÍNA DE LA NIÑEZ
                                </button>
                            </div>
                        </section>
                    )}

                    {/* Blue Section with kid5 and Teleton text - Desktop */}
                    {!fullScreen && (
                        <section style={{
                            backgroundColor: '#1FA3DB',
                            width: '100%',
                            padding: '60px 10.4%'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                maxWidth: '100%',
                                gap: '60px'
                            }}>
                                {/* Left side - Image */}
                                <div style={{
                                    width: '40%'
                                }}>
                                    <img
                                        src={kid5}
                                        alt="Kid"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            borderRadius: '15px'
                                        }}
                                    />
                                </div>

                                {/* Right side - Text */}
                                <div style={{
                                    width: '60%',
                                    color: '#ffffff'
                                }}>
                                    <p style={{
                                        fontSize: '24px',
                                        lineHeight: 1.6,
                                        fontFamily: 'inherit',
                                        margin: 0,
                                        color: '#ffffff'
                                    }}>
                                        El 2024, gracias a la Teletón beneficiamos a más de 2.500 niñas y niños menores de seis años mediante servicios de salud y rehabilitación, distribuir vitamina A a más de 1.8 millones de niños y niñas, vacunar a 180 mil menores, y equipar 35 centros de salud infantil.
                                    </p>
                                </div>
                            </div>

                            {/* Centered text below */}
                            <div style={{
                                textAlign: 'center',
                                marginTop: '50px'
                            }}>
                                <p style={{
                                    fontSize: '28px',
                                    fontWeight: 'bold',
                                    color: '#ffffff',
                                    fontFamily: 'inherit',
                                    margin: 0
                                }}>
                                    En tus manos está el futuro de la niñez boliviana
                                </p>
                            </div>
                        </section>
                    )}

                    {/* Orange DONAR AHORA Button after Blue Section - Desktop */}
                    {!fullScreen && (
                        <WhiteSection>
                            <DonarAhoraButton onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />
                        </WhiteSection>
                    )}

                    {/* Security Section with kid6 - Desktop */}
                    {!fullScreen && (
                        <section style={{
                            backgroundColor: '#ffffff',
                            width: '100%',
                            padding: '60px 10.4%',
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                maxWidth: '892px',
                                width: '100%',
                                gap: '40px',
                                alignItems: 'center'
                            }}>
                                {/* Left side - Image */}
                                <div style={{
                                    width: '40%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <img
                                        src={kid6}
                                        alt="Security"
                                        style={{
                                            width: '100%',
                                            maxHeight: '195px',
                                            objectFit: 'cover',
                                            borderRadius: '10px'
                                        }}
                                    />
                                </div>

                                {/* Right side - Text */}
                                <div style={{
                                    width: '60%'
                                }}>
                                    {/* Blue heading */}
                                    <h3 style={{
                                        color: '#1FA3DB',
                                        fontSize: '24px',
                                        fontWeight: 'bold',
                                        fontFamily: 'inherit',
                                        marginBottom: '15px',
                                        lineHeight: 1.3
                                    }}>
                                        Tu donación está segura con UNICEF
                                    </h3>

                                    {/* Description text */}
                                    <p style={{
                                        color: '#333333',
                                        fontSize: '16px',
                                        lineHeight: 1.6,
                                        fontFamily: 'inherit',
                                        margin: 0
                                    }}>
                                        Nuestro sistema de donaciones está diseñado para proteger todos tus datos personales y tu método de pago. Todos nuestros procedimientos físicos y digitales cuentan con altos estándares de seguridad para que puedas realizar tus aportaciones de manera segura.
                                    </p>
                                </div>
                            </div>
                        </section>
                    )}

                    {/* Final DONAR AHORA Button - Desktop */}
                    {!fullScreen && (
                        <WhiteSection>
                            <DonarAhoraButton onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />
                        </WhiteSection>
                    )}

                </>
            </div>
            {fullScreen && (
                <>
                    <div className="donation-form"
                         style={fullScreen ? {width: "100%", padding: "0"} : {left: "5%", width: 512, zIndex: 999999, top: "350px"}}>
                        <Grid container spacing={0}>
                            <Grid item xs={12} style={{backgroundColor: "#FFFA2F", width: "100%"}}>
                                <Typography
                                    sx={{mb: {xs: 4, md: 3, lg: 2}, mt: {xs: 4, md: 3, lg: 2}}}
                                    variant={fullScreen ? "h3" : "h4"}
                                    style={{
                                        textAlign: fullScreen ? "center" : "left",
                                        color: fullScreen ? "#000" : "#000",
                                        marginTop: "16px",
                                        marginBottom: "16px",

                                    }}>
                                <span
                                    className={fullScreen ? "font-face-UniversBold" : "font-face-UniversLight"}
                                >
                                    Selecciona el monto que quieres donar.
                                </span>
                                </Typography>
                            </Grid>
                            {/* Row 1 - 120 and 170 */}
                            <Grid item xs={6}>
                                <ColorButton style={{
                                    color: "#fff",
                                    borderRadius: 45,
                                    textTransform: "capitalize",
                                    border: "2px solid #fff",
                                    backgroundColor: amount === 120 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                    marginTop: "8px"
                                }} selected onClick={() => {
                                    setError("");
                                    setAmount(120);
                                    setShowAmount(false);
                                    setImgDonacion(true)
                                }} variant="contained"><span
                                    className={"font-face-UniversBold"}>Bs 120</span></ColorButton>
                            </Grid>
                            <Grid item xs={6} style={{position: "relative"}}>
                                <div style={{
                                    position: "absolute",
                                    top: "-8px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "#fff",
                                    color: "#1FA3DB",
                                    padding: "4px 12px",
                                    borderRadius: "12px",
                                    fontSize: "11px",
                                    fontWeight: "bold",
                                    zIndex: 10,
                                    whiteSpace: "nowrap"
                                }}>
                                    Popular ♥
                                </div>
                                <div style={{
                                    border: "2px dashed #1FA3DB",
                                    borderRadius: "50px",
                                    padding: "4px",
                                    position: "relative",
                                    marginTop: "0px"
                                }}>
                                    <ColorButton style={{
                                        color: "#fff",
                                        borderRadius: 45,
                                        textTransform: "capitalize",
                                        border: "2px solid #fff",
                                        backgroundColor: amount === 170 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                    }} onClick={() => {
                                        setError("");
                                        setAmount(170);
                                        setShowAmount(false);
                                        setImgDonacion(true)
                                    }} variant="contained"><span
                                        className={"font-face-UniversBold"}>Bs 170</span></ColorButton>
                                </div>
                                <div style={{
                                    position: "absolute",
                                    bottom: "-27px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    color: "#1FA3DB",
                                    fontSize: "11px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    zIndex: 10,
                                    whiteSpace: "nowrap",
                                    lineHeight: "1"
                                }}>
                                    <div style={{fontSize: "24px", marginBottom: "-2px"}}>▼</div>
                                    Opción más elegida
                                </div>
                            </Grid>
                            {/* Row 2 - 250 and Otro Monto Mayor */}
                            <Grid item xs={6} style={{marginTop: "30px"}}>
                                <ColorButton style={{
                                    color: "#fff",
                                    borderRadius: 45,
                                    textTransform: "capitalize",
                                    border: "2px solid #fff",
                                    backgroundColor: amount === 250 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                }} onClick={() => {
                                    setError("");
                                    setAmount(250);
                                    setShowAmount(false);
                                    setImgDonacion(true)
                                }} variant="contained"><span
                                    className={"font-face-UniversBold"}>Bs 250</span></ColorButton>
                            </Grid>
                            <Grid item xs={6} style={{marginTop: "30px"}}>
                                <ColorButton
                                    style={{
                                        color: "#fff",
                                        borderRadius: 45,
                                        textTransform: "capitalize",
                                        border: "2px solid #fff",
                                        backgroundColor: amount !== 120 && amount !== 170 && amount !== 250 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                        fontSize: "1.1rem",
                                        lineHeight: "1"
                                    }} onClick={() => {
                                    setAmount(250);
                                    setShowAmount(true);
                                    setImgDonacion(true)
                                }} variant="contained"><span className={"font-face-UniversBold"}>Otro Monto Mayor</span></ColorButton>
                            </Grid>

                            <Grid item lg={12} xs={12} mt={1} style={{textAlign: "center"}}>
                                {showAmount ?
                                    <ButtonGroup
                                        style={{width: "100%"}}
                                        disableElevation
                                        variant="contained"
                                        aria-label="Disabled elevation buttons"
                                    >
                                        <TextField style={{width: "50%"}}
                                                   className="amount-text"
                                                   value={amount}
                                                   onChange={handleChange}
                                                   onKeyDown={handleChange}/>
                                        <ColorButton onClick={donate} style={{width: "50%",
                                            backgroundColor: "#FFFA2F",
                                            color:"#000"}}><span
                                            className={"font-face-UniversBold"}>Dona Ahora</span></ColorButton>
                                    </ButtonGroup>
                                    :
                                    <ColorButton style={{borderRadius: 35, width: fullScreen ? "50%" : "60%",backgroundColor: "#FFFA2F",
                                        color:"#000"}}
                                                 onClick={donate}>Dona Ahora</ColorButton>
                                }
                            </Grid>

                            {error !== "" &&
                                <Grid item lg={12} xs={12} mt={1}>
                                    <div style={{
                                        background: "#000",
                                        zIndex: "99",
                                        fontSize: "1rem",
                                        fontWeight: 600,
                                        textAlign: "center",
                                        color: "#fff",
                                        padding: 5,
                                        borderRadius: 5
                                    }}>
                                        <WarningAmberIcon variant="h6" sx={{fontSize: "2rem", marginRight: 1}}/>
                                        {error}
                                    </div>
                                </Grid>
                            }
                        </Grid>
                    </div>

                    {/* Blue Section - Mobile */}
                    <section style={{
                        backgroundColor: '#1FA3DB',
                        width: '100%',
                        marginTop: '25px',
                        padding: '30px 20px'
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '20px'
                        }}>
                            {/* Text */}
                            <div style={{
                                textAlign: 'center'
                            }}>
                                <Typography
                                    variant="h3"
                                    style={{
                                        color: '#ffffff',
                                        fontWeight: 'bold',
                                        lineHeight: 1.4,
                                        margin: 0,
                                        fontSize: '1.8rem'
                                    }}
                                    className="font-face-UniversBold"
                                >
                                    Con una sola donación, puedes cambiar el futuro de niñas y niños en Bolivia. Ayúdalos a acceder a salud, educación y protección.
                                </Typography>
                            </div>

                            {/* Donate Button */}
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '30px'
                            }}>
                                <button
                                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                    style={{
                                        backgroundColor: '#EE5B28',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '35px',
                                        padding: '12px 30px',
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        fontFamily: 'inherit',
                                        cursor: 'pointer',
                                        textTransform: 'uppercase'
                                    }}
                                    className="font-face-UniversBold"
                                >
                                    DONAR AHORA
                                </button>
                            </div>
                        </div>
                    </section>

                    {/* White Section with Blue Text and Info - Mobile */}
                    <section style={{
                        backgroundColor: '#ffffff',
                        width: '100%',
                        padding: '40px 20px',
                        textAlign: 'center'
                    }}>
                        {/* Blue Text */}
                        <Typography
                            variant="h4"
                            style={{
                                color: '#1FA3DB',
                                fontWeight: 'bold',
                                lineHeight: 1.4,
                                margin: 0,
                                fontSize: '1.5rem',
                                marginBottom: '10px'
                            }}
                            className="font-face-UniversBold"
                        >
                            Tú puedes cambiar sus vidas.
                        </Typography>
                        <Typography
                            variant="body1"
                            style={{
                                color: '#333333',
                                fontSize: '16px',
                                lineHeight: 1.8,
                                fontFamily: 'inherit',
                                marginBottom: '30px'
                            }}
                        >
                            Tu donación se transforma en ayuda directa que llega a los lugares más alejados del país.
                        </Typography>

                        {/* Info Section - Mobile */}
                        <div style={{
                            backgroundColor: '#ffffff',
                            width: '100%',
                            padding: '30px 15px',
                            marginTop: '30px',
                            borderRadius: '10px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
                        }}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>
                                {/* Main image and orange section together */}
                                <div style={{
                                    width: '100%',
                                    maxWidth: '95%'
                                }}>
                                    <img
                                        src={kid1}
                                        alt="Kid"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            display: 'block'
                                        }}
                                    />

                                    {/* Orange section with rows */}
                                    <div style={{
                                        backgroundColor: '#ffffff',
                                        padding: '30px 10px',
                                        width: '100%'
                                    }}>
                                        {/* Equivalencias header */}
                                        <div style={{
                                            color: '#1FA3DB',
                                            fontSize: '24px',
                                            fontWeight: 'bold',
                                            fontFamily: 'inherit',
                                            marginBottom: '20px',
                                            textAlign: 'center'
                                        }}>
                                            Equivalencias:
                                        </div>

                                        {/* Row 1 */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '25px'
                                        }}>
                                            <img
                                                src={kid11}
                                                alt="Kit"
                                                style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    marginRight: '15px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div style={{
                                                display: 'flex',
                                                width: '100%',
                                                flex: 1
                                            }}>
                                                <div style={{
                                                    width: '40%',
                                                    fontSize: '24px',
                                                    fontWeight: 'bold',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    Bs 120 =
                                                </div>
                                                <div style={{
                                                    width: '60%',
                                                    fontSize: '18px',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    textAlign: 'right',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    2.285 niñas y niños reciben vitamina A en todo el país.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 2 */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '25px'
                                        }}>
                                            <img
                                                src={kid12}
                                                alt="Kit"
                                                style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    marginRight: '15px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div style={{
                                                display: 'flex',
                                                width: '100%',
                                                flex: 1
                                            }}>
                                                <div style={{
                                                    width: '40%',
                                                    fontSize: '24px',
                                                    fontWeight: 'bold',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    Bs 170 =
                                                </div>
                                                <div style={{
                                                    width: '60%',
                                                    fontSize: '18px',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    textAlign: 'right',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    8 niñas y niños reciben kits de estimulación temprana en todo el país.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 3 */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            <img
                                                src={kid13}
                                                alt="Kit"
                                                style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    marginRight: '15px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div style={{
                                                display: 'flex',
                                                width: '100%',
                                                flex: 1
                                            }}>
                                                <div style={{
                                                    width: '40%',
                                                    fontSize: '24px',
                                                    fontWeight: 'bold',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    Bs 250 =
                                                </div>
                                                <div style={{
                                                    width: '60%',
                                                    fontSize: '18px',
                                                    color: '#333333',
                                                    fontFamily: 'inherit',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    textAlign: 'right',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    10 niñas y niños reciben kits de estimulación temprana en todo el país.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                        {/* Donate Button - moved outside shadow container */}
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '30px'
                        }}>
                            <button
                                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                style={{
                                    backgroundColor: '#EE5B28',
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '35px',
                                    padding: '12px 30px',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    fontFamily: 'inherit',
                                    cursor: 'pointer',
                                    textTransform: 'uppercase'
                                }}
                                className="font-face-UniversBold"
                            >
                                DONAR AHORA
                            </button>
                        </div>
                    </section>

                    {/* Blue Section with kid5 and Teleton text - Mobile */}
                    <section style={{
                        backgroundColor: '#1FA3DB',
                        width: '100%',
                        padding: '40px 20px'
                    }}>
                        {/* Image and text container */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '30px'
                        }}>
                            {/* Image */}
                            <div style={{
                                width: '80%',
                                maxWidth: '300px'
                            }}>
                                <img
                                    src={kid5}
                                    alt="Kid"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        borderRadius: '15px'
                                    }}
                                />
                            </div>

                            {/* Text */}
                            <div style={{
                                color: '#ffffff',
                                textAlign: 'center'
                            }}>
                                <p style={{
                                    fontSize: '18px',
                                    lineHeight: 1.6,
                                    fontFamily: 'inherit',
                                    margin: 0,
                                    color: '#ffffff'
                                }}>
                                    El 2024, gracias a la Teletón beneficiamos a más de 2.500 niñas y niños menores de seis años mediante servicios de salud y rehabilitación, distribuir vitamina A a más de 1.8 millones de niños y niñas, vacunar a 180 mil menores, y equipar 35 centros de salud infantil.
                                </p>
                            </div>
                        </div>

                        {/* Centered text below */}
                        <div style={{
                            textAlign: 'center',
                            marginTop: '40px'
                        }}>
                            <p style={{
                                fontSize: '22px',
                                fontWeight: 'bold',
                                color: '#ffffff',
                                fontFamily: 'inherit',
                                margin: 0
                            }}>
                                En tus manos está el futuro de la niñez boliviana
                            </p>
                        </div>
                    </section>

                    {/* Orange DONAR AHORA Button after Blue Section - Mobile */}
                    <WhiteSection mobile={true}>
                        <DonarAhoraButton 
                            mobile={true}
                            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
                        />
                    </WhiteSection>

                    {/* Security Section with kid6 - Mobile */}
                    <section style={{
                        backgroundColor: '#ffffff',
                        width: '100%',
                        padding: '40px 20px'
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '25px',
                            maxWidth: '100%'
                        }}>
                            {/* Image */}
                            <div style={{
                                width: '80%',
                                maxWidth: '280px',
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <img
                                    src={kid6}
                                    alt="Security"
                                    style={{
                                        width: '100%',
                                        maxHeight: '160px',
                                        objectFit: 'cover',
                                        borderRadius: '10px'
                                    }}
                                />
                            </div>

                            {/* Text content */}
                            <div style={{
                                textAlign: 'center',
                                width: '100%'
                            }}>
                                {/* Blue heading */}
                                <h3 style={{
                                    color: '#1FA3DB',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    fontFamily: 'inherit',
                                    marginBottom: '12px',
                                    lineHeight: 1.3
                                }}>
                                    Tu donación está segura con UNICEF
                                </h3>

                                {/* Description text */}
                                <p style={{
                                    color: '#333333',
                                    fontSize: '14px',
                                    lineHeight: 1.6,
                                    fontFamily: 'inherit',
                                    margin: 0
                                }}>
                                    Nuestro sistema de donaciones está diseñado para proteger todos tus datos personales y tu método de pago. Todos nuestros procedimientos físicos y digitales cuentan con altos estándares de seguridad para que puedas realizar tus aportaciones de manera segura.
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Final DONAR AHORA Button - Mobile */}
                    <WhiteSection mobile={true}>
                        <DonarAhoraButton 
                            mobile={true}
                            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
                        />
                    </WhiteSection>

                </>
            )}
        </>
    );
}

OneShot.propTypes = {};

export default OneShot;
